import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetResidentRetentionRequestDtoSchema = z.object({
  facilityId: z.number(),
  from: z.string(),
  to: z.string(),
  comparisonSet: z.enum(['INTERNAL', 'COMP']).optional(),
});

const GetResidentRetentionResponseDtoSchema = z.object({
  marketMedian: z.number().nullable(),
  currentValue: z.number().nullable(),
  hint: z.string(),
  message: z.string(),
});

export type GetResidentRetentionRequestDto = z.infer<
  typeof _GetResidentRetentionRequestDtoSchema
>;
export type GetResidentRetentionResponseDto = z.infer<
  typeof GetResidentRetentionResponseDtoSchema
>;

export const getResidentRetention = async (
  params: GetResidentRetentionRequestDto,
  config?: AxiosRequestConfig<GetResidentRetentionRequestDto>
) => {
  const { facilityId, ...restParams } = params;

  return api
    .get(
      `/market-intelligence/facilities/${facilityId}/resident-retention-kpi`,
      {
        params: restParams,
        ...config,
      }
    )
    .then(responseContract(GetResidentRetentionResponseDtoSchema));
};
